import React from 'react';
import { FormattedDate, FormattedRelativeTime, FormattedTime } from 'react-intl';
export default function DateTime(props) {
    var date = props.date, className = props.className, relativeTimeClasses = props.relativeTimeClasses, timeClasses = props.timeClasses, dateClasses = props.dateClasses, hideTime = props.hideTime, compact = props.compact;
    if (!date) {
        return null;
    }
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "d-block" },
            React.createElement("i", { className: dateClasses }),
            React.createElement(FormattedDate, { value: date }),
            " ",
            !hideTime && React.createElement(FormattedTime, { value: date })),
        !compact &&
            React.createElement("div", { className: relativeTimeClasses },
                React.createElement("i", { className: timeClasses }),
                React.createElement(FormattedRelativeTime, { value: (date.getTime() - Date.now()) / 1000, updateIntervalInSeconds: 60 }))));
}
DateTime.defaultProps = {
    className: '',
    timeClasses: 'fe fe-clock mr-2',
    dateClasses: 'fe fe-calendar mr-2',
    relativeTimeClasses: '',
};
